import { render, staticRenderFns } from "./IconWallet.vue?vue&type=template&id=54bf8a1b&scoped=true"
import script from "./IconWallet.vue?vue&type=script&lang=js"
export * from "./IconWallet.vue?vue&type=script&lang=js"
import style0 from "./IconWallet.vue?vue&type=style&index=0&id=54bf8a1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf8a1b",
  null
  
)

export default component.exports